/* eslint-disable prettier/prettier */
import { Vue, Vuex } from "./CoreBase";
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

class UserLogged {
	isLogged: boolean = false;
	perPage: number = -1;
	fullNameOrLogin: string = '';
	homePageIdentifier: string = '';
	idUser: number = -1;
	idPerson: number = -1;
	idTenant: number = -1;
	idStudent: number = -1;
	isSuperUser: boolean = false;
	userRight: string[] = [''];
	tenantModules: ModuleItem[] = [{ identifier: '', isVisible: false }];
	lastRoutePage: string = '';
	lastRoutePageQuery: string[] = [''];
	TOKEN_JwtToken: string = '';
	TOKEN_RefreshToken: string = '';
	versionNumber: string = '';
	tenantLanguages: string[] = [''];
	currentLanguage: string = '';
	canChangeLanguage: boolean = true;
	askBeforeDelete: boolean = true;
	askBeforeCancelEditing: boolean = true;
	showInfoMessagesOnDetail: boolean = true;
	operationalDispatching: OperationalDispatching = { showParams: true, idCentre: -1, idConnection: -1, date: '' };
	planSheet: PlanSheet = { idWorkingPlan: -1, isTemplate: '' };
	workingCalendar: WorkingCalendar = { idWorkingGroup: '', period: '', idEmployment: -1 };
	travelCost: TravelCost = { center: -1, period: -1 };
	workBook: WorkBook = { center: '', period: '', day: '' };
	operationalRecord: OperationalRecord = { center: -1, period: -1 };
	taking: Taking = { center: '', period: '' };
	settingType: string = '';
	notAssigned: boolean = false;
	workShiftSchedule: WorkShiftSchedule = { idWorkingGroup: '', period: '', idEmployment: -1 };
	tenantList: TenantList[] = [];
	allowOAuth: boolean = false;
	formIsInEditMode: boolean = false;
	mainDataChanged: boolean = false;
	mainDataChangedSub: boolean = false;
	selfRegistration: boolean = false;
	showDetailParamFirstShow: boolean = false;
	pageTimer: number = -1;
	ignoreDiacritics: boolean = false;
	isTestEnvironment: boolean = false;
	showTestPage: boolean = false;
	globalSearchItemCount: number = -1;
	globalSearch: string = '';
	notificationRefreshTimer: number = -1;
	notificationCount: number = -1;
	//tabulky
	currentPage: any[] = [{ name: '', value: 1 }];
	isShowGrid: any[] = [{ name: '', value: false }];
	perPageTable: any[] = [{ name: '', value: -1 }];
	totalRows: any[] = [{ name: '', value: 0 }];
	sortDesc: any[] = [{ name: '', value: false }];
	sortBy: any[] = [{ name: '', value: '' }];
	filterAll: any[] = [{ name: '', value: null }];
	selectedColumns: any[] = [{ name: '', value: null }];
	optionsColumns: any[] = [{ name: '', value: null }];
	isSelfRegistrationUser: boolean = false;
	isTeacher: boolean = false;
	//filterAllTest: any[] = [];
}

class TenantList {
	value: number = -1;
	text: string = '';
	identif: string = '';
}

class Taking {
	center: string = '';
	period: string = '';
}

class OperationalRecord {
	center: number = -1;
	period: number = -1;
}

class WorkBook {
	center: string = '';
	period: string = '';
	day: string = '';
}

class TravelCost {
	center: number = -1;
	period: number = -1;
}

class WorkShiftSchedule {
	idWorkingGroup: string = '';
	period: string = '';
	idEmployment: number = -1;
}

class WorkingCalendar {
	idWorkingGroup: string = '';
	period: string = '';
	idEmployment: number = -1;
}

class OperationalDispatching {
	showParams: boolean = true;
	idCentre: number = -1;
	idConnection: number = -1;
	date: string = '';
}

class PlanSheet {
	idWorkingPlan: number = -1;
	isTemplate: string = '';
}

class ModuleItem {
	identifier: string = '';
	isVisible: boolean = false;
}

const vuexLocal = new VuexPersistence<UserLogged>({
	key: 'userLogin',
	storage: window.sessionStorage
});

export default new Vuex.Store<UserLogged>({

	state: {
		isLogged: false,
		perPage: -1,
		fullNameOrLogin: '',
		homePageIdentifier: '',
		idUser: -1,
		idPerson: -1,
		idStudent: -1,
		idTenant: -1,
		isSuperUser: false,
		userRight: [''],
		tenantModules: [],
		lastRoutePage: '',
		lastRoutePageQuery: [''],
		TOKEN_JwtToken: '',
		TOKEN_RefreshToken: '',
		versionNumber: '',
		tenantLanguages: [''],
		currentLanguage: '',
		canChangeLanguage: true,
		askBeforeDelete: true,
		askBeforeCancelEditing: true,
		showInfoMessagesOnDetail: true,
		operationalDispatching: { showParams: true, idCentre: -1, idConnection: -1 , date: ''},
		planSheet: { idWorkingPlan: -1, isTemplate: '' },
		workingCalendar: { idWorkingGroup: '', period: '', idEmployment: -1 },
		travelCost: { center: -1, period: -1 },
		workBook: { center: '', period: '', day: '' },
		operationalRecord: { center: -1, period: -1 },
		taking: { center: '', period: '' },
		settingType: '',
		notAssigned: false,
		workShiftSchedule: { idWorkingGroup: '', period: '', idEmployment: -1 },
		tenantList: [],
		allowOAuth: false,
		formIsInEditMode: false,
		mainDataChanged: false,
		mainDataChangedSub:false,
		selfRegistration: false,
		showDetailParamFirstShow: false,
		pageTimer: -1,
		ignoreDiacritics: false,
		isTestEnvironment: false,
		showTestPage: false,
		globalSearchItemCount: -1,
		notificationRefreshTimer: -1,
		notificationCount: -1,
		globalSearch: '',
		//tabulka p�esun
		currentPage: [{ name: '', value: 1 }],
		isShowGrid: [{ name: '', value: false }],
		perPageTable: [{ name: '', value: -1 }],
		filterAll: [{ name: '', value: null }],
		selectedColumns: [{ name: '', value: null }],
		optionsColumns: [{ name: '', value: null }],
		totalRows: [{ name: '', value: 0 }],
		sortDesc: [{ name: '', value: false }],
		sortBy: [{ name: '', value: '' }],
		isSelfRegistrationUser: false,
		isTeacher: false
		//filterAllTest:[]
	},

	mutations: {
		//Region sta
		currentPage(state, currentPage) {
			let exists = state.currentPage.find((c: any) => c.name == currentPage.name);
			if (exists != undefined) {
				exists.value = currentPage.value;
			}
			else {
				state.currentPage.push({ name: currentPage.name || '', value: currentPage.value });
			}
		},

		isShowGrid(state, isShowGrid) {
			let exists = state.isShowGrid.find((c: any) => c.name == isShowGrid.name);
			if (exists != undefined) {
				exists.value = isShowGrid.value;
			}
			else {
				state.isShowGrid.push({ name: isShowGrid.name || '', value: isShowGrid.value });
			}
		},

		perPageTable(state, perPageTable) {
			let exists = state.perPageTable.find((c: any) => c.name == perPageTable.name);
			if (exists != undefined) {
				exists.value = perPageTable.value;
			}
			else {
				state.perPageTable.push({ name: perPageTable.name || '', value: perPageTable.value });
			}
		},

		totalRows(state, totalRows) {
			let exists = state.totalRows.find((c: any) => c.name == totalRows.name);
			if (exists != undefined) {
				exists.value = totalRows.value;
			}
			else {
				state.totalRows.push({ name: totalRows.name || '', value: totalRows.value });
			}
		},

		sortDesc(state, sortDesc) {
			let exists = state.sortDesc.find((c: any) => c.name == sortDesc.name);
			if (exists != undefined) {
				exists.value = sortDesc.value;
			}
			else {
				state.sortDesc.push({ name: sortDesc.name || '', value: sortDesc.value });
			}
		},

		sortBy(state, sortBy) {
			let exists = state.sortBy.find((c: any) => c.name == sortBy.name);
			if (exists != undefined) {
				exists.value = sortBy.value;
			}
			else {
				state.sortBy.push({ name: sortBy.name || '', value: sortBy.value });
			}
		},

		filterAll(state, filterAll) {
			let exists = state.filterAll.find((c: any) => c.name == filterAll.name);
			if (exists != undefined) {
				exists.value = filterAll.value;
			}
			else {
				state.filterAll.push({ name: filterAll.name || '', value: filterAll.value });
			}
		},

		selectedColumns(state, selectedColumns) {
			let exists = state.selectedColumns.find((c: any) => c.name == selectedColumns.name);
			if (exists != undefined) {
				exists.value = selectedColumns.value;
			}
			else {
				state.selectedColumns.push({ name: selectedColumns.name || '', value: selectedColumns.value });
			}
		},

		optionsColumns(state, optionsColumns) {
			let exists = state.optionsColumns.find((c: any) => c.name == optionsColumns.name);
			if (exists != undefined) {
				exists.value = optionsColumns.value;
			}
			else {
				state.optionsColumns.push({ name: optionsColumns.name || '', value: optionsColumns.value });
			}
		},

		globalSearch(state, globalSearch) {
			state.globalSearch = globalSearch;
		},

		notificationCount(state, notificationCount) {
			state.notificationCount = notificationCount;
		},

		globalSearchItemCount(state, globalSearchItemCount) {
			state.globalSearchItemCount = globalSearchItemCount;
		},

		mainDataChanged(state, mainDataChanged) {
			state.mainDataChanged = mainDataChanged;
		},

		mainDataChangedSub(state, mainDataChangedSub) {
			state.mainDataChangedSub = mainDataChangedSub;
		},

		formIsInEditMode(state, formIsInEditMode) {
			state.formIsInEditMode = formIsInEditMode;
		},		

		askBeforeDelete(state, askBeforeDelete) {
			state.askBeforeDelete = askBeforeDelete;
		},

		askBeforeCancelEditing(state, askBeforeCancelEditing) {
			state.askBeforeCancelEditing = askBeforeCancelEditing;
		},

		showInfoMessagesOnDetail(state, showInfoMessagesOnDetail ) {
			state.showInfoMessagesOnDetail = showInfoMessagesOnDetail;
		},

		allowOAuth(state, allowOAuth) {
			state.allowOAuth = allowOAuth;
		},

		perPage(state, perPage) {
			state.perPage = perPage;
		},

		pageTimer(state, pageTimer) {
			state.pageTimer = pageTimer;
		},

		ignoreDiacritics(state, ignoreDiacritics) {
			state.ignoreDiacritics = ignoreDiacritics;
		},

		isTestEnvironment(state, isTestEnvironment) {
			state.isTestEnvironment = isTestEnvironment;
		},

		showTestPage(state, showTestPage) {
			state.showTestPage = showTestPage;
		}, 

		notAssigned(state, notAssigned) {
			state.notAssigned = notAssigned;
		},

		settingType(state, setting) {
			state.settingType = setting;
		},

		taking(state, taking) {
			state.taking.center = taking.center;
			state.taking.period = taking.period;
		},

		operationalRecord(state, operationalRecord) {
			state.operationalRecord.center = operationalRecord.center;
			state.operationalRecord.period = operationalRecord.period;
		},

		workBook(state, workBook) {
			state.workBook.center = workBook.center;
			state.workBook.period = workBook.period;
			state.workBook.day = workBook.day;
		},

		travelCost(state, travelCost) {
			state.travelCost.center = travelCost.center;
			state.travelCost.period = travelCost.period;
		},

		workingCalendar(state, workingCalendar) {
			state.workingCalendar.idWorkingGroup = workingCalendar.idWorkingGroup;
			state.workingCalendar.period = workingCalendar.period;
			state.workingCalendar.idEmployment = workingCalendar.idEmployment;
		},

		workShiftSchedule(state, workingCalendar) {
			state.workShiftSchedule.idWorkingGroup = workingCalendar.idWorkingGroup;
			state.workShiftSchedule.period = workingCalendar.period;
			state.workShiftSchedule.idEmployment = workingCalendar.idEmployment;
		},

		planSheet(state, planSheet) {
			state.planSheet.idWorkingPlan = planSheet.idWorkingPlan;
			state.planSheet.isTemplate = planSheet.isTemplate;
		},


		operationalDispatching(state, operDis) {
			state.operationalDispatching.idCentre = operDis.idCentre;
			state.operationalDispatching.idConnection = operDis.idConnection;
			state.operationalDispatching.showParams = operDis.showParams;
			state.operationalDispatching.date = operDis.date;
		},

		login(state, payload) {
			state.isLogged = payload.isLogged;
			state.perPage = payload.perPage;
			state.idUser = payload.idUser;
			state.idPerson = payload.idPerson;
			state.idTenant = payload.idTenant;
			state.idStudent = payload.idStudent;
			state.fullNameOrLogin = payload.fullNameOrLogin;
			state.homePageIdentifier = payload.homePageIdentifier;
			state.isSuperUser = payload.isSuperUser;
			state.userRight = payload.rights;
			state.tenantModules = payload.tenantModules;
			state.TOKEN_JwtToken = payload.jwtToken;
			state.TOKEN_RefreshToken = payload.refreshToken;
			state.tenantLanguages = payload.tenantLanguages;
			state.currentLanguage = payload.currentLanguage;
			state.askBeforeDelete = payload.askBeforeDelete;
			state.askBeforeCancelEditing = payload.askBeforeCancelEditing;
			state.showInfoMessagesOnDetail = payload.showInfoMessagesOnDetail;
			state.allowOAuth = payload.allowOAuth;
			state.showDetailParamFirstShow = payload.showDetailParamFirstShow;
			state.pageTimer = payload.pageTimer;
			state.ignoreDiacritics = payload.ignoreDiacritics;
			state.isTestEnvironment = payload.isTestEnvironment;
			state.showTestPage = payload.showTestPage;
			state.globalSearchItemCount = payload.globalSearchItemCount;
			state.notificationRefreshTimer = payload.notificationRefreshTimer;
			state.isSelfRegistrationUser = payload.isSelfRegistrationUser;
			state.isTeacher = payload.isTeacher;
		},

		logout(state) {
			state.isLogged = false;
			state.perPage = 0;
			state.fullNameOrLogin = '';
			state.homePageIdentifier = '';
			state.idUser = -1;
			state.idStudent = -1;
			state.idPerson = -1;
			state.idTenant = -1;
			state.isSuperUser = false;
			state.userRight = [''];
			state.tenantModules = [];
			state.TOKEN_JwtToken = '';
			state.TOKEN_RefreshToken = '';
			state.tenantLanguages = [''];
			state.currentLanguage = '';
			state.canChangeLanguage = true;
			state.askBeforeDelete = true;
			state.askBeforeCancelEditing = true;
			state.showInfoMessagesOnDetail = true;
			state.allowOAuth = false;
			state.selfRegistration = false;
			state.showDetailParamFirstShow = false;
			state.tenantList = [];
			state.tenantModules = [{ identifier: '', isVisible: false }];
			state.pageTimer = -1;
			state.ignoreDiacritics = false;
			state.isTestEnvironment = false;
			state.showTestPage = false;
			state.globalSearch = '';
			state.notificationRefreshTimer = -1;
			state.notificationCount = -1;
			state.currentPage = [{ name: '', value: 1 }];
			state.isShowGrid= [{ name: '', value: false }];
			state.perPageTable= [{ name: '', value: -1 }];
			state.filterAll= [{ name: '', value: null }];
			state.selectedColumns= [{ name: '', value: null }];
			state.optionsColumns= [{ name: '', value: null }];
			state.totalRows= [{ name: '', value: 0 }];
			state.sortDesc= [{ name: '', value: false }];
			state.sortBy = [{ name: '', value: '' }];
			state.isSelfRegistrationUser = false;
			state.isTeacher = false;
		},

		setShowDetailParamFirstShow(state, showDetailParamFirstShow: boolean) {
			state.showDetailParamFirstShow = showDetailParamFirstShow;
		},

		setIsSelfRegistrationUser(state, isSelfRegistrationUser: boolean) {
			state.isSelfRegistrationUser = isSelfRegistrationUser;
		},

		setSelfRegistrationstate(state, selfRegistration: boolean) {
			state.selfRegistration = selfRegistration;
		},

		setTenantList(state, tenantList: TenantList[]) {
			state.tenantList = tenantList;
		},

		setIdTenant(state, idTenant: number) {
			state.idTenant = idTenant;
		},

		setTenantModules(state, tenantModules: any) {
			state.tenantModules = tenantModules;
		},

		setLanguage(state, language: string) {
			state.currentLanguage = language;
		},

		setVersionNumber(state, payload) {
			state.versionNumber = payload.versionNumber;
		},

		clearTokens(state) {
			state.TOKEN_JwtToken = '';
			state.TOKEN_RefreshToken = '';
		},
		setTokens(state, payload) {
			state.TOKEN_JwtToken = payload.jwtToken;
			state.TOKEN_RefreshToken = payload.refreshToken;
		},
		setLastRoutePage(state, lastRoutePage: string) {
			if (lastRoutePage) {
				state.lastRoutePage = lastRoutePage;
			}
		},
		setLastRoutePageQuery(state, lastRoutePageQuery: string[]) {
			if (lastRoutePageQuery) {
				state.lastRoutePageQuery = lastRoutePageQuery;
			}
		},
		clearLastRoutePage(state) {
			state.lastRoutePage = '';
			state.operationalDispatching.idConnection = -1;
			state.operationalDispatching.idCentre = -1;
			state.operationalDispatching.date = '';
			state.operationalDispatching.showParams = true;
		}
	},

	plugins: [vuexLocal.plugin],
	actions: {}
});

